import React from "react";

import { SvgIconProps } from "@mui/material";
import {
  AudioRepoIcon,
  DocRepoIcon,
  FormOutlined,
  ImageRepoIcon,
  MailRepoIcon,
  OtherRepoIcon,
  PDFRepoIcon,
  PPTRepoIcon,
  SpreadsheetRepoIcon,
  VideoRepoIcon
} from "assets/material-custom-icons";

import { EntityType, FileType } from "../../../constants";

type IconComponent = React.ComponentType<{ sx?: SvgIconProps["sx"] }>;

const fileRepoIconsHash: Record<string, IconComponent> = {
  [FileType.JPG]: ImageRepoIcon,
  [FileType.PNG]: ImageRepoIcon,
  [FileType.JPEG]: ImageRepoIcon,
  [FileType.CSV]: SpreadsheetRepoIcon,
  [FileType.XLX]: SpreadsheetRepoIcon,
  [FileType.XLS]: SpreadsheetRepoIcon,
  [FileType.XLSX]: SpreadsheetRepoIcon,
  [FileType.PDF]: PDFRepoIcon,
  [FileType.DOC]: DocRepoIcon,
  [FileType.DOCX]: DocRepoIcon,
  [FileType.PPT]: PPTRepoIcon,
  [FileType.PPTX]: PPTRepoIcon,
  [EntityType.FORM]: FormOutlined,
  [EntityType.EMAIL]: MailRepoIcon,
  [FileType.FILE]: OtherRepoIcon,
  [EntityType.DOCUMENT]: FormOutlined,
  [EntityType.FOLDER]: OtherRepoIcon,
  // Audio & video types
  wav: AudioRepoIcon,
  mp3: AudioRepoIcon,
  audio: AudioRepoIcon,
  mp4: VideoRepoIcon,
  mov: VideoRepoIcon,
  video: VideoRepoIcon
};

interface FileRepoIconProps {
  type: FileType | string;
  sx?: SvgIconProps["sx"];
}

export const FileRepoIcon: React.FC<FileRepoIconProps> = ({ type, sx }) => {
  const Icon = fileRepoIconsHash[type] ?? OtherRepoIcon;

  return <Icon sx={{ fontSize: 16, fill: "#26a6ae", ...sx }} />;
};
